import { Component, OnInit } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { appConfig } from '../config-farma';
import { RoleManagerService } from '@services/role-manager.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'pharma-app';

    constructor(
        private manager: RoleManagerService
    ) { }

    ngOnInit(): void {
        // setear configuración de la app
        this.manager.setOrigin(appConfig.origin);
    }
}
